"use client";

import { createContext, useContext } from "react";

const RadioContext = createContext();

export function RadioGroup({
    value,
    onChange,
    children,
    className = "",
}) {
    return (
        <RadioContext.Provider value={{ value, onChange }}>
            <div className={`flex flex-col gap-3 ${className}`}>
                {children}
            </div>
        </RadioContext.Provider>
    );
}

export const useRadioGroup = () => useContext(RadioContext);